import React, {Children} from 'react';

interface LinkProps {
  href: string;
  hash: string;
  activeClass?: string;
}

const Link: React.FC<LinkProps> = ({ href, hash, activeClass, children }) => {
  const external = href.startsWith('http');

  if (external) {
    return (
      <a href={href} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  } else {
    const child = Children.only(children);
    // @ts-ignore
    const childClassName = child?.props.className || '';

    const hashIndex = href.indexOf("#");
    const hrefHash = href.substring(hashIndex);

    const className =
      hash === hrefHash
        ? `${childClassName} ${activeClass}`.trim()
        : childClassName;

    return (
      <a href={href}>
        {/* @ts-ignore */}
        {React.cloneElement(child, {
          className: className || null,
        })}
      </a>
    );
  }
};

export default Link;
